import cloneDeep from 'lodash/cloneDeep';
import { createSelector } from 'reselect';

export const getState = createSelector(
  state => state.atg__stomp,
  state => cloneDeep(state),
);
